import { useTranslate } from '@growtherapy/i18n';
import { Button } from '@growtherapy/sprout-ui';

export type ContactSupportButtonProps = {
  contactSupportUrl: string;
};

export function ContactSupportButton({ contactSupportUrl }: ContactSupportButtonProps) {
  const t = useTranslate();
  return (
    <Button
      onClick={() => {
        window.open(contactSupportUrl, '_blank');
      }}
    >
      {t('telehealth-core:core.contactSupport')}
    </Button>
  );
}
